import { ShippingDetails } from "./shippingDetails";
import { Cart } from "./cart";

export class Checkout {
    shippingDetails: ShippingDetails;
    cart: Cart;
}